/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditor', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor.html'),

      replace: false,

      scope: {
        _default: '=ngModel',
        variables: '=',
      },

      link(scope, element, attrs) {
        const $icon = element.find('.modal-icon-use');
        $icon.attr('href', `#icons-sprite_${scope.component.icon}`);
      },
    };
  },
]);
